import React from 'react';
import ReactMarkdown from 'react-markdown';

// Aucun HTML brut ni image distante : une réponse IA ne déclenche pas de requête externe.
export const OtoMessageText = ({ text, testId }) => <div className="oto-message-markdown min-w-0 break-words text-sm leading-relaxed text-[#1A2421]" data-testid={testId}>
  <ReactMarkdown skipHtml components={{
    a: ({ children }) => <span className="underline underline-offset-2">{children}</span>,
    img: () => null,
    h1: ({ children }) => <h3 className="mt-3 text-base font-semibold">{children}</h3>,
    h2: ({ children }) => <h3 className="mt-3 text-base font-semibold">{children}</h3>,
    h3: ({ children }) => <h3 className="mt-3 text-sm font-semibold">{children}</h3>,
    pre: ({ children }) => <pre className="max-w-full whitespace-pre-wrap break-words bg-[#F3F5F1] p-3 text-xs [overflow-wrap:anywhere]">{children}</pre>,
  }}>{text}</ReactMarkdown>
</div>;